import React from 'react';
import Carousel from "react-multi-carousel";
import {CarouselImage} from "../../../../components/Carousel/Carousel.style";
import IconButton from "@material-ui/core/IconButton";
import {ChevronLeft, ChevronRight, Close} from "@material-ui/icons";

const responsive = {
	desktop: {
		breakpoint: {max: 9999, min: 768},
		items: 1,
		slidesToSlide: 1,
	},
	tablet: {
		breakpoint: {max: 768, min: 464},
		items: 1,
		slidesToSlide: 1,
	},
	mobile: {
		breakpoint: {max: 464, min: 0},
		items: 1,
		slidesToSlide: 1,
	},
};

const CustomLeftArrow = ({onClick}) => (
	<IconButton
		onClick={onClick}
		style={{
			position: "absolute",
			left: 8,
			top: "50%",
			transform: "translateY(-50%)",
			color: "black",
			zIndex: 2,
		}}
	>
		<ChevronLeft fontSize="large"/>
	</IconButton>
);

const CustomRightArrow = ({onClick}) => (
	<IconButton
		onClick={onClick}
		style={{
			position: "absolute",
			right: 8,
			top: "50%",
			transform: "translateY(-50%)",
			color: "black",
			zIndex: 2,
		}}
	>
		<ChevronRight fontSize="large"/>
	</IconButton>
);

const ImagesCarousel = ({sliders = [], image = null, onRemove}) => {
	// Merge main image with sliders into one array
	const allImages = image ? [{id: 9999999, image_url: image}, ...sliders] : [...sliders];
	const hasImages = allImages.length > 0;

	return (
		<div className="w-100 h-100 bg-transparent" style={{position: "relative"}}>
			<Carousel
				arrows={hasImages}
				responsive={responsive}
				ssr
				showDots={false}
				infinite={hasImages}
				containerClass="container-with-dots"
				autoPlay={false}
				autoPlaySpeed={4000}
				renderButtonGroupOutside
				additionalTransfrom={0}
				customLeftArrow={hasImages ? <CustomLeftArrow/> : null}
				customRightArrow={hasImages ? <CustomRightArrow/> : null}
			>
				{hasImages ? (
					allImages.map((elem, index) => {
						// Check if this is the main image (first item when image exists)
						const isMainImage = index === 0 && image !== null;

						return (
							<div
								key={index}
								style={{
									padding: "0px",
									overflow: "hidden",
									position: "relative",
								}}
							>
								{/* Show remove button for all images except main image */}
								{!isMainImage && (
									<IconButton
										onClick={() => onRemove(elem)}
										style={{
											position: "absolute",
											top: 8,
											right: 8,
											backgroundColor: "rgba(0,0,0,0.5)",
											color: "white",
											zIndex: 5,
										}}
										size="small"
									>
										<Close fontSize="small"/>
									</IconButton>
								)}

								<div style={{display: "flex", cursor: "pointer"}}>
									<CarouselImage
										src={elem.image_url}
										alt="carousel-image"
										style={{
											width: "100%",
											height: "auto",
											objectFit: "contain"
										}}
										onError={(e) => {
											e.target.onerror = null;
											e.target.src = require("../../../../assets/icons/delishop_logo2.svg");
										}}
									/>
								</div>
							</div>
						);
					})
				) : (
					<div
						style={{
							padding: "0px",
							overflow: "hidden",
							position: "relative",
							minHeight: 400,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<CarouselImage
							src={require("../../../../assets/icons/delishop_logo2.svg")}
							alt="default-logo"
							style={{
								width: "100%",
								height: "auto",
								objectFit: "contain"
							}}
						/>
					</div>
				)}
			</Carousel>
		</div>
	);
};

export default ImagesCarousel;